import { Box, Skeleton } from '@mui/material';
import { ILoadingCellRendererParams } from 'ag-grid-community';
import React, { JSX } from 'react';

import { gridClasses } from './HBAgGrid.styles';

const LoadingCellRenderer = (
  props: ILoadingCellRendererParams & { loadingMessage: string },
): JSX.Element => {
  return (
    <Box sx={{ ...gridClasses.gridCustomLoading }}>
      <Box m={0.5} sx={{ lineHeight: 25 }}>
        <Skeleton animation="wave" variant="rectangular" width={100} />
      </Box>
      <Box m={0.5} sx={{ lineHeight: 25 }}>
        <Skeleton variant="rectangular" width={100} />
      </Box>
      <Box m={0.5} sx={{ lineHeight: 25 }}>
        <Skeleton animation="wave" variant="rectangular" width={100} />
      </Box>
      <Box m={0.5} sx={{ lineHeight: 25 }}>
        <Skeleton variant="rectangular" width={100} />
      </Box>
      <Box m={0.5} sx={{ lineHeight: 25 }}>
        <Skeleton animation="wave" variant="rectangular" width={100} />
      </Box>
      <Box m={0.5} sx={{ lineHeight: 25 }}>
        <Skeleton variant="rectangular" width={100} />
      </Box>
      <Box m={0.5} sx={{ lineHeight: 25 }}>
        <Skeleton animation="wave" variant="rectangular" width={100} />
      </Box>
      <Box m={0.5} sx={{ lineHeight: 25 }}>
        <Skeleton variant="rectangular" width={100} />
      </Box>
      <Box m={0.5} sx={{ lineHeight: 25 }}>
        <Skeleton animation="wave" variant="rectangular" width={100} />
      </Box>
      <Box m={0.5} sx={{ lineHeight: 25 }}>
        <Skeleton variant="rectangular" width={100} />
      </Box>
    </Box>
  );
};

export default LoadingCellRenderer;
